//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DataEstrategyService from '@/apps/data-platform/services/data_estrategy/reports';
import domainService from '@/apps/data-platform/services/master_data/domain_service';
import module_dashboard_service from '@/apps/data-platform/services/reports/module_dashboard_service';
import tasks from '@/js/tasks';
export default {
  name: 'ModuleDashboardAdminComponent',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    module: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      item: null,
      valid: true,
      report: {
        type: 'POWERBI'
      },
      readonly: false,
      organizations: [],
      update_hours: [],
      created: false,
      types: [{
        value: 'POWERBI',
        text: 'Power BI'
      }]
    };
  },
  created: function created() {
    this.getReport();
  },
  methods: {
    getOrganizations: function getOrganizations() {
      var _this = this;
      domainService.getOrganizationsDetail().then(function (response) {
        if (response.success && response.code === 200) {
          response.data.forEach(function (x) {
            _this.organizations.unshift({
              name: x.alias,
              id: x.code
            });
          });
        }
      });
    },
    getReport: function getReport() {
      var _this2 = this;
      var request = {
        "module": this.module,
        "id": this.id
      };
      module_dashboard_service.getReport(request).then(function (response) {
        if (response.data) {
          _this2.report = response.data;
          _this2.created = true;
        } else {
          _this2.created = false;
          _this2.report = {
            type: 'POWERBI'
          };
        }
      });
    },
    onChangeAllPermission: function onChangeAllPermission(event) {
      if (event) {
        this.report.organizations = [];
      }
    },
    updateReport: function updateReport() {
      var _this3 = this;
      if (!this.$refs.form.validate()) {
        return;
      }
      this.report.id = this.id;
      module_dashboard_service.updateReport(this.report).then(function (response) {
        if (response.success && response.code === 200) {
          tasks.toast.success('Actualizado!');
          _this3.getReport();
        }
      });
    },
    createReport: function createReport() {
      var _this4 = this;
      if (!this.$refs.form.validate()) {
        return;
      }
      this.report.id = this.id;
      this.report.module = this.module;
      module_dashboard_service.createReport(this.report).then(function (response) {
        if (response.success && response.code === 200) {
          tasks.toast.success('Creado!');
          _this4.getReport();
        }
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getOrganizations();
    this.getReport();
  },
  computed: {
    rules: function rules() {
      var _this5 = this;
      return {
        general: [function (v) {
          return !!v || _this5.translate('reglas.field');
        }],
        update_hours: [function (v) {
          return !!v.length || _this5.translate('reglas.field');
        }, function (v) {
          return v.length >= 2 || _this5.translate('reglas.insights_min_2_update_hours');
        }]
      };
    },
    getClassTable: function getClassTable() {
      return 'col-sm-12';
    }
  }
};